import { get, isArray } from 'lodash';
import React from 'react';
import { TreeNodeType } from 'src/lib/types/types';
import { checkIfErklaerungenHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import ErklaerungGlobal, { getFormStrucErklaerungGlobal } from './content/ErklaerungGlobal';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureErklaerungGlobal = (application: any, readOnly: boolean) => {
	const hasValidErklaerung = (erklaerungen: any[]) => {
		if (isArray(erklaerungen) && erklaerungen.length > 0) {
			return erklaerungen.some((ele) => get(ele, 'Inhalt', '').trim() !== '');
		} else {
			return false;
		}
	};

	let treeNodes: TreeNodeType[] = [];

	const pflichtErklaerungen = get(application, P.Erklaerungen_Pflichterklaerungen.path, []);
	const optionaleErklaerungen = get(application, P.Erklaerungen_Optionale_Erklaerungen.path, []);

	const hasCommentErklaerungen = checkIfErklaerungenHasComment(readOnly, application);

	if (hasValidErklaerung(pflichtErklaerungen) || hasValidErklaerung(optionaleErklaerungen)) {
		treeNodes = [
			{
				label: 'Erklärung',
				content: <ErklaerungGlobal hasComment={hasCommentErklaerungen} />,
				hasComment: hasCommentErklaerungen,
				formStruc: getFormStrucErklaerungGlobal(application),
			},
		];
	}

	return treeNodes;
};
